








































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { classList,addClassPanel,logoutPanel,dialogPanel,sortPanel } from '@/components';
import { TbGoods, TbGoodsClass } from '@/http';
import { Toast } from 'vant';
@Component({
    components: {
        classList,addClassPanel,logoutPanel,dialogPanel,sortPanel,
    },
})
export default class classManage extends Vue {
   
    public $refs: {
    }; 

    @Prop({
        default:false
    })
    show:Boolean;

    list= [];

    /**新增分类类型
     * true：一级分类
     * false：二级分类
     */
     isParent=true;

    addClassShow = false;
    /**一级分类信息 */
    firstInfo:any={};

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    /**提示弹窗类型
     * 1：分类未使用时，删除提醒
     */
    tipType=1;
    isTiping = false;
    deleteClassInfo:any={};
    /**分类排序 */
    sortShow=false; 
    /**编辑分类 */
    editShow=false;
    editInfo:any={};
    isEditing = false;
    /**新增分类需要调接口 */
    needJk = true;

    isSorting = false;

    created() {
    }

    mounted(){
        this.init();
    }

    async init(){
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount:true
        }) 
        this.list = res;
    }

    /**新增分类 */
    addClass(type,needJk=true){
        this.needJk= needJk;
        this.isParent = type;
        this.addClassShow=true;
        this.$refs['addClassPanel'].init1(this.isParent);
        if(!type){
            this.$refs['addClassPanel'].init(this.firstInfo);
        }
       
    }
    /**新增二级分类 */
    addSecondClass(item,needJk=true){
        this.needJk = needJk;
        let form = Object.assign({},item,{
            sort:0
        })
        this.firstInfo = form;
        this.addClass(false,needJk);
    }

    closeFun(){
        this.addClassShow = false;
    }

    confirmSave(){
        this.init();
    }
    /**删除分类 */
    deleteClass(item){
        /**分类下无商品 */
        if(item.goodsCount==0){
            this.tipTitle = "删除提醒";
            this.tipText = `确定删除“${item.name}”分类吗？`;
            this.btnNums=2;
            this.confirmText = "确定删除";
            this.cancelText = "取消";
            this.tipShow=true;
            this.deleteClassInfo = item;
            this.tipType = 1;
        }else{
            this.tipTitle = "删除提醒";
            this.tipText = `分类“${item.name}”已被使用，删除后商品将归属至“其他分类”`;
            this.btnNums=2;
            this.confirmText = "确定删除";
            this.cancelText = "取消";
            this.tipShow=true;
            this.deleteClassInfo = item;
            this.tipType = 1;
        }
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                await this.deleteClassFun(this.deleteClassInfo.id);     
                break;
            case 2:
                await this.deleteClassFun(this.deleteClassInfo.id,true);     
                break;
        
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    /**删除分类 */
    async deleteClassFun(id,isSecond=false){
        if(this.isTiping) return;
        this.isTiping = true;
        try {
            let res = await TbGoodsClass.DeleteTbGoodsClass(id);
            if(isSecond){
                await this.getSecondList(this.editInfo.id);
            }else{
                this.editShow = false;
            }
            await this.init();
            Toast("删除成功")
            this.isTiping = false;
        } catch (error) {
            this.isTiping = false;
        }
    }
    closecm(){
        this.$emit('closeFun');
    }
    /**排序 */
    showSortFun(){
        this.sortShow = true;
    }
    closeSortFun(){
        this.sortShow = false;
    }
    /**编辑分类 */
    closeEditFun(){
        this.editShow = false;
    }
    async editClass(item){
        this.editInfo = item;
        this.editShow = true;
        await this.getSecondList(item.id);
        
    }
    async getSecondList(id){
        let res = await TbGoodsClass.GetTbGoodsClassByIsParent({
            isparent:false,
            parentid:id
        })
        let arr = res.map(v=>{
            return{
                ...v,
                updateType:2
            }
        });
        // console.log('arr',arr);
        this.editInfo.items = arr;
        this.$nextTick(()=>{
            this.$refs['sorPanelSec'].getSecondList(arr);
        })
    }
    confirmAdd(item){
        console.log('item',item);
        this.getSecondList(this.editInfo.id);
        // this.$refs['sorPanelSec'].addItem(item)
    }
    /**编辑 */
    async confirmEdit(){
        console.log(this.editInfo,this.$refs['sorPanelSec'].componentList,this.$refs['sorPanelSec'].deleteList);
        if(!this.editInfo.name){
            Toast("请输入一级分类名称");
            return
        }
        if(this.isEditing)return;
        this.isEditing = true;
        let childList = [];
        let arr1=this.$refs['sorPanelSec'].componentList.filter(vv=>vv.name).map((v,index)=>{
            return {
                id:v.id,
                name:v.name,
                sort:index+1,
                updateType:v.updateType,
            }
        })
        let arr2=this.$refs['sorPanelSec'].deleteList.map((v,index)=>{
            return {
                id:v.id,
                name:v.name,
                sort:index+1,
                updateType:3,
            }
        })
        childList = arr1.concat(arr2);
        try {
            let res =await TbGoodsClass.PutTbGoodsClass({
                id:this.editInfo.id,
                name:this.editInfo.name,
                sort:0,
                updateType:2,
                childList:childList
            })
            Toast("修改成功");
            this.editShow = false;
            this.isEditing = false;
            await this.init();
            } catch (error) {
            this.isEditing = false;
        }
    }

    async saveSort(){
        if(this.isSorting) return;
        this.isSorting = true;
        try {
            let arr= this.$refs['firstSort'].componentList.map((v,index)=>{
                return {
                    id:v.id,
                    sort:index+1
                }
            })
            let res = await TbGoodsClass.TbGoodsClassSort(arr);
            await this.init();
            Toast("保存成功");
            this.sortShow = false;
            this.isSorting = false;
        } catch (error) {
            this.isSorting = false;
        }
    }

    async deleteBySortFun(item){
        console.log('item',item);
        let id = this.editInfo.id+','+item.id
        let res = await TbGoods.GetGoodsList({shopId: JSON.parse(localStorage.getItem('padUserinfo')).shopId,goodsClassId:id,skip:0,count:-1});
        if(res.totalCount==0){
            this.tipTitle = "删除提醒";
            this.tipText = `确定删除“${item.name}”分类吗？`;
            this.btnNums=2;
            this.confirmText = "确定删除";
            this.cancelText = "取消";
            this.tipShow=true;
            this.deleteClassInfo = item;
            this.tipType = 2;
        }else{
            this.tipTitle = "删除提醒";
            this.tipText = `分类“${item.name}”已被使用，删除后商品将归属至“其他分类”`;
            this.btnNums=2;
            this.confirmText = "确定删除";
            this.cancelText = "取消";
            this.tipShow=true;
            this.deleteClassInfo = item;
            this.tipType = 2;
        }
    }
    
    
     
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/components/classManage.vue